export default __webpack_public_path__ + "static/upioneTimemandate-2b23a90893b608270a67a26a29c15867.webp";